import React from 'react';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import CtySpinner from '../spinner/CtySpinner';
import { Image } from '@nextui-org/react';
import { ID_CONSTANTS } from '../utils/constants';

interface FileUploadCardProps {
  activeChatAdvisor?: any;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  handleFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileLoading: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  uploadedImageUrl: string;
  subText?: string;
  accept?: string;
  previewType?: 'image' | 'file';
  uploadedFileLabel?: string;
}

const CtyFileUploader: React.FC<FileUploadCardProps> = ({
  activeChatAdvisor,
  handleDrop,
  subText,
  handleFileInputChange,
  fileLoading,
  inputRef,
  uploadedImageUrl,
  accept = '*',
  previewType = 'image',
  uploadedFileLabel,
}) => {
  const { t } = useTranslation();
  const hasFilePreview = previewType === 'file' && Boolean(uploadedFileLabel || uploadedImageUrl);
  const hasImagePreview = previewType === 'image' && Boolean(uploadedImageUrl);
  const showUploadIcon = !(hasFilePreview || hasImagePreview);

  return (
    <div
      id={activeChatAdvisor?.advisor_id + ID_CONSTANTS.uploadCard}
      onDragOver={(e) => e.preventDefault()}

      onDrop={(e) => {
        e.preventDefault();
        handleDrop(e);
      }}
      onClick={() => inputRef.current && inputRef.current.click()}
      className="h-[240px] p-8 rounded-lg shadow-custom outline-dashed outline-[#D0D5DD] dark:outline-[#30363d] flex flex-col justify-center cursor-pointer flex-1"
    >
      <div className="h-full flex flex-col items-center justify-center">
        {showUploadIcon && <div className="p-2 outline outline-[#EAECF0] dark:outline-[#30363d] rounded-lg">
          {fileLoading ? (
            <CtySpinner size="sm" />
          ) : (
            <Icon icon="icon-park-outline:upload-one" width="22" height="22" className="text-black dark:text-[#f5f5f5]" />
          )}
        </div>}
        <div className="text-center">
          {fileLoading ? (
            <div>{t('Uploading Files...')}</div>
          ) : (
            <div className='flex flex-col items-center'>

              {hasImagePreview && (
                <div>
                  <Image
                    alt=""
                    height={100}
                    radius="sm"
                    src={uploadedImageUrl}
                    width={100}
                    className="mt-4 z-0"
                  />
                </div>
              )}
              {hasFilePreview && (
                <div className="mt-4 flex flex-col items-center gap-2">
                  <Icon icon="mdi:file-document-outline" width="40" height="40" className="text-[#475467]" />
                  <p className="text-sm text-default-600 max-w-[220px] truncate">
                    {uploadedFileLabel || uploadedImageUrl}
                  </p>
                </div>
              )}
              <span className="flex pb-2 pt-2">
                <p className="text-primary font-bold text-md pr-2">{t('Click to upload')}</p>
                <p>{t('or drag and drop')}</p>
              </span>
              {subText && <div className="text-sm">{subText}</div>}
            </div>


          )}
        </div>
        <div className="mt-2 flex justify-center space-x-4 mb-2">
          <input
            id="file-input"
            ref={inputRef}
            type="file"
            accept={accept}
            onChange={handleFileInputChange}
            className="hidden"
            disabled={fileLoading}
          />
        </div>
      </div>
    </div>
  );
};

export { CtyFileUploader };
